import(/* webpackMode: "eager", webpackExports: ["CBRatesTable"] */ "/app/app/(finance)/finance/components/CBRatesTable.tsx");
